import { Component, OnInit } from '@angular/core';
import { Store } from '../store';
import { ActivatedRoute } from '@angular/router';
import { StoreService } from '../store.service';
import { StoreTypeService } from '../../store_types/store-type.service';
import { Country } from '../../countries/country';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';

@Component({
  selector: 'app-store-crud',
  templateUrl: './store-crud.component.html',
  styleUrls: ['./store-crud.component.css'],
  providers: [StoreService,StoreTypeService]
})
export class StoreCrudComponent implements OnInit {

   id: any = null;
   stores: Store;
   msgs: Message[] = [];
   selectedItemByID: string;
   button_caption: string ="Сохранить"
   button_icon: string ="fa fa-save";

  constructor(private storeService: StoreService,private storeTypeService: StoreTypeService,private activatedRoute: ActivatedRoute) {

  		 activatedRoute.params.subscribe(params=>{this.id=params['id']});

   		  if(this.id){

   		  				this.storeTypeService.getStoreTypeList().subscribe(response=>{this.stores.store_types=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});console.log(this.stores.store_types);})


   		  			this.storeService.getStoreById(this.id).subscribe(response=>{
   		  			   	let tmp = response['data'].store_types.id;
   		  		    	response['data'].store_types=null;
   		  				this.stores=response['data'];

   		  			
   		  						this.storeTypeService.getStoreTypeList().subscribe(response=>{this.stores.store_types=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})
   		  						 this.selectedItemByID=tmp;
   		  			});	

   		 			this.button_caption="Редактировать";
   		 			this.button_icon="fa fa-edit";
   		  }else{
					this.storeTypeService.getStoreTypeList().subscribe(response=>{this.stores.store_types=response['data'].map(function(value: any){
	    			    return {label:value.name, value: value.id};
	  				});})
   		  }

   }

  ngOnInit() {

  	 this.stores = {
			id: "",
			name: "",
			store_types: [],
			available: false
  	 }
  }


  crud(form: NgForm):void{

   		  if(!this.id){
   		  		this.storeService.createStore(form.value)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);});

   		  }else{
   		  	this.storeService.updateStore(form.value,this.id)
   		  		.subscribe((data) => {this.msgs.push({severity:'success', summary:'Сообщение', detail: "Успешно: "+data});console.log(data);});
   		  }



  }	 

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/stores/store-crud/store-crud.component.ts